import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import PricePeriodsGrid from "../Grid/PricePeriodsGrid"
import {Tab, Tabs} from "@material-ui/core";
import { getBars } from './help/GetBars';
import LoadingModal from './help/LoadingModal';
import {MATERIAL_UI_PROPS} from "../../lib/data";

const PricePeriods = (props) => {
    const [pickedRate, setPickedRate] = useState(0)

    useEffect(() => {
        props.getAllItems();
    }, []);

    let grid = <Typography variant={"body1"}>Загрузка... </Typography>;

    if (!props?.rates && !props?.barPrices) {
        grid = <LinearProgress mt={4} />;
    } else if (
        props?.rates?.length > 0
    ) {
        const { bars, childBars, baseBars, baseBarIds } = getBars(props.rates);

        const getActiveTabIndex = () => {
            if (!pickedRate) return 0;
            const index = baseBars.findIndex(bar => bar.id === pickedRate.id);
            return index >= 0 ? index : 0;
        };

        const bases =
            baseBars.length > 0 &&
            baseBars.map((rate) => {
                    return (
                        <Tab
                            title={rate.code !== rate.name ? rate.name : ""}
                            label={rate.code || rate.name}
                            key={`${rate.id}/${rate.code}`}
                            onClick={() => {
                                setPickedRate(rate);
                            }}
                        />
                    );
                });

        const periods = {};

        props?.barPrices?.forEach(period => {
            if (!periods[period?.rate_id]) {
                periods[period?.rate_id] = {};
            }
            periods[period?.rate_id][period?.date] = period.bar_id;
        });

        grid = (
            <>
                {bases && <Box mt={4}>
                    <Tabs
                        value={getActiveTabIndex()}
                        indicatorColor={MATERIAL_UI_PROPS.colors.primary}
                        textColor={MATERIAL_UI_PROPS.colors.primary}
                        variant="scrollable"
                        scrollButtons="true"
                    >
                        {bases}
                    </Tabs>
                </Box>}
                <Box>
                    <PricePeriodsGrid
                        pickedRate={pickedRate}
                        setPickedRate={setPickedRate}
                        bars={bars}
                        baseBars={baseBars}
                        barPrices={periods}
                        hotelId={props.hotelId}
                        childBars={childBars}
                        getAllItems={props.getAllItems}
                        setLoading={props.setLoading}
                    />
                </Box>
            </>
        );
    }

  return (
      <Paper elevation={3}>
          <LoadingModal loading={props.loading} />
          <Box p={3}>
              <Typography mb={3} variant={"h5"}>
                  {props.title}
              </Typography>
          </Box>
          <Box mt={4}>
              {grid}
          </Box>
      </Paper>
  );
};

export default PricePeriods;
